<script lang="ts">
	import { clickoutside } from '@svelte-put/clickoutside';
	import { twMerge } from 'tailwind-merge';
	import RoundClose from 'virtual:icons/ic/round-close';

	let className = '',
		modalEl: HTMLDialogElement,
		isCloseable = true;

	export { className as class, isCloseable, modalEl };
</script>

<dialog on:close bind:this={modalEl} class="modal">
	<div class="modal-box {twMerge('relative p-8', className)}" use:clickoutside on:clickoutside>
		<slot />
		{#if isCloseable}
			<button
				on:click|stopPropagation|preventDefault={() => modalEl.close()}
				type="button"
				class="btn btn-circle btn-sm absolute right-3 top-3"
				aria-label="Tutup"
				title="Tutup"
			>
				<RoundClose class="text-lg" />
			</button>
		{/if}
	</div>
</dialog>
